import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import "./ActionBarMobileLoader.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import MiniSearchContainer from "app/features/SearchEngine/MiniSearch/MiniSearchContainer";

export const ActionBarMobileLoader = ({
	className,
	showSortLoader,
	showMiniSearch,
	showMapLoader,
	...props
}) => {
	const actionBarClassName = classNames("action-bar-mobile-loader", {
		[className]: className,
	});

	return (
		<div className={actionBarClassName} {...props} aria-hidden="true">
			{showMiniSearch && <MiniSearchContainer />}

			<div className="action-bar-mobile-loader__buttons">
				<LoaderBar width="60px" height="12px" />

				{showSortLoader && <LoaderBar width="60px" height="12px" />}

				{showMapLoader && <LoaderBar width="60px" height="12px" />}
			</div>
		</div>
	);
};

ActionBarMobileLoader.propTypes = {
	className: PropTypes.string,
	showMiniSearch: PropTypes.bool,
	showSortLoader: PropTypes.bool,
	showMapLoader: PropTypes.bool,
};
